import type { ReactNode } from "react";
import { AlertTriangle, HelpCircle } from "lucide-react";
import { Dialog } from "./Overlay";

/**
 * 唯一正式高风险确认弹窗。删除、退款、停服、强制迁移等不可逆动作必须说明影响、提供取消。
 */
export function ConfirmDialog({ title, description, confirmLabel = "确认执行", cancelLabel = "取消", tone = "primary", onConfirm, onClose, busy = false, busyLabel = "正在执行…", confirmDisabled = false, children }: {
  title: string;
  description: string;
  confirmLabel?: string;
  cancelLabel?: string;
  tone?: "primary" | "danger";
  onConfirm: () => void;
  onClose: () => void;
  busy?: boolean;
  busyLabel?: string;
  confirmDisabled?: boolean;
  children?: ReactNode;
}) {
  return <Dialog title={title} description={description} onClose={onClose}>
    {children && <div className="confirm-body">
      {tone === "danger" && <div className="confirm-risk" role="alert"><AlertTriangle size={16} aria-hidden /><span>此操作影响较大，请确认影响范围后再执行。</span></div>}
      {children}
    </div>}
    <footer className="dialog-footer">
      <button type="button" className="button secondary" onClick={onClose} disabled={busy}>{cancelLabel}</button>
      <button type="button" className={`button ${tone === "danger" ? "danger" : "primary"}`} onClick={onConfirm} disabled={busy || confirmDisabled}>{busy ? busyLabel : confirmLabel}</button>
    </footer>
  </Dialog>;
}

/** 需要补充说明但无高风险的确认。 */
export function InfoConfirmDialog({ title, description, confirmLabel, onConfirm, onClose, busy }: {
  title: string;
  description: string;
  confirmLabel: string;
  onConfirm: () => void;
  onClose: () => void;
  busy?: boolean;
}) {
  return <Dialog title={title} description={description} onClose={onClose}>
    <div className="confirm-body">
      <div className="confirm-info"><HelpCircle size={16} aria-hidden /><span>请确认以上信息无误后再继续。</span></div>
    </div>
    <footer className="dialog-footer">
      <button type="button" className="button secondary" onClick={onClose} disabled={busy}>取消</button>
      <button type="button" className="button primary" onClick={onConfirm} disabled={busy}>{busy ? "正在执行…" : confirmLabel}</button>
    </footer>
  </Dialog>;
}
